module.exports = __webpack_public_path__ + "static/media/11.d0c0e555.png";